import { Checkbox } from '@mui/material';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import type { ChangeEvent } from 'react';
import { QTableHead, QTableRow, QTableCell, QTableSortableColumnHeader } from '@kw/quokka-ui';
// eslint-disable-next-line import/extensions
import { DeviceOwnerStatus } from './enum/DeviceOwnerKeyMaps.enum';

interface Header {
  title: string;
  onClick?: () => void;
  sortValue?: null | 'ASC' | 'DESC';
}
interface TableHeader {
  enrolled: Header[];
  pending: Header[];
  unenrolled: Header[];
}
interface IProps {
  setPage: (newPage: number, event?: any) => void;
  ownerStatus: (typeof DeviceOwnerStatus)[keyof typeof DeviceOwnerStatus];
  numSelected: number;
  rowCount: number;
  tableHeaders: TableHeader;
  onSelectAllClick: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

export default function DeviceOwnersTableHead({ setPage, ownerStatus, numSelected, rowCount, tableHeaders, onSelectAllClick }: IProps) {
  const selectedTableHeaders =
    ownerStatus === DeviceOwnerStatus.ENROLLED
      ? tableHeaders.enrolled
      : ownerStatus === DeviceOwnerStatus.PENDING
      ? tableHeaders.pending
      : tableHeaders.unenrolled;

  return (
    <QTableHead>
      <QTableRow>
        {ownerStatus !== DeviceOwnerStatus.ENROLLED && (
          <>
            <QTableCell padding="checkbox">
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                indeterminateIcon={<IndeterminateCheckBoxOutlinedIcon />}
                inputProps={{
                  'aria-label': `select all ${String(ownerStatus).toLowerCase()} device owners`,
                }}
              />
            </QTableCell>
          </>
        )}
        {selectedTableHeaders.map(({ title, onClick, sortValue }) => (
          <QTableSortableColumnHeader
            key={title}
            title={title}
            onClick={() => {
              onClick();
              setPage(1);
            }}
            sortValue={sortValue}
          />
        ))}
      </QTableRow>
    </QTableHead>
  );
}
